import React from "react";
import CategoryFilteredVisits from "./CategoryFilteredVisits";

const PhysicalsList = (props) => {
  return (
    <CategoryFilteredVisits
      {...props}
      visitCategories={["Employer Services - Physicals"]}
      title="Employer Services - Physicals"
      screenType="physicals"
    />
  );
};

export default PhysicalsList;
